import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { dict } from "./dict";
import { errCode } from "./api";

const Ctx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("xd_lang") || "he");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = "rtl";
    localStorage.setItem("xd_lang", lang);
  }, [lang]);

  const t = useCallback((k, vars) => {
    let s = dict[lang][k] ?? dict.he[k] ?? k;
    if (vars) Object.entries(vars).forEach(([a, b]) => { s = s.split(`{${a}}`).join(b); });
    return s;
  }, [lang]);

  const tErr = useCallback((e) => {
    const c = errCode(e);
    return dict[lang][`err.${c}`] || `${dict[lang]["err.generic"]}${c ? ` (${c})` : ""}`;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, tErr }), [lang, t, tErr]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
